

export default {

    methods: {

        validate() {

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$toast.global.my_error({message: 'Please fill all required fields'})
                return false
            }

            return true
        },

        getState(field) {

            if(field.$dirty === false) {
                return null
            }

            return !field.$error
        }

    }

}

